<template>
  <div class="asc-advanced-custom-alerts-is-shared--wrapper">
    <div>
      <div class="asc-align">
        <asc-tooltip
          :tooltip-length="100"
          :tooltip="isDataBricksRunning ? tooltipMsg : ''"
          :left="true"
        >
          <v-radio-group
            v-model="isShared"
            row
            hide-details
            :disabled="isDataBricksRunning || isReadOnly"
            @change="handleFilterChange"
          >
            <v-radio
              v-for="(option, index) in getIsSharedOptions"
              v-show="!option.hide"
              :key="index"
              :label="option.label"
              :value="option.value"
              class="radioWrapper"
            ></v-radio>
          </v-radio-group>
        </asc-tooltip>

        <asc-info-label
          v-if="getIsSharedDisabled"
          class="inline-message"
          value="Custom parameters cannot be used in an analytic that's visible to your entire airline."
        />
      </div>
    </div>
    <p class="isSharedMessage">{{ getIsSharedMessage }}</p>
    <asc-dialog
      :show-dialog="showShareAlertConfirmationDialog"
      :text="getShareAlertConfirmationDialogHeader"
      :on-primary="handleShareAlertConfirmation"
      :on-secondary="cancelShareAlert"
      secondary-button-text="Cancel"
      primary-button-text="Confirm"
      :on-close="onCloseDialog"
    >
      {{ getShareAlertConfirmationText }}
    </asc-dialog>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import AscDialog from '@/components/atoms/AscDialog'
import AscInfoLabel from '@/components/molecules/AscInfoLabel'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  name: 'AscAdvancedCustomAlertsIsSharedWrapper',

  components: {
    AscLabel,
    AscDialog,
    AscInfoLabel,
    AscTooltip,
  },

  props: {
    tooltipMsg: {
      type: String,
      default: '',
    },
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    alertData: {
      type: Object,
      default: () => {},
    },
    airline: {
      type: String,
      default: '',
    },
    isSharedDisabled: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showShareAlertConfirmationDialog: false,
    }
  },

  computed: {
    isShared: {
      get() {
        return this.alertData?.isShared === true
      },
      set(val) {
        this.$emit('isShared', val)
      },
    },
    getIsSharedMessage() {
      return `You will receive an email notification for analytic alerts that only you can see. By selecting "All of ${this.airline}," this analytic will generate maintenance issue in Ascentia for all of ${this.airline} to see.`
    },
    getIsSharedOptions() {
      return [
        { label: 'Only Me', value: false, hide: false },
        {
          label: `All of ${this.airline}`,
          value: true,
          hide: this.isSharedDisabled,
        },
      ]
    },
    getShareAlertConfirmationText() {
      return `Upon activation, triggered analytics will display to all of ${this.airline} within Ascentia.`
    },
    getShareAlertConfirmationDialogHeader() {
      return 'SHARE ANALYTICS?'
    },
    getIsSharedDisabled() {
      return this.isSharedDisabled
    },
  },
  methods: {
    handleFilterChange(event) {
      this.showShareAlertConfirmationDialog = event
    },
    handleShareAlertConfirmation() {
      this.showShareAlertConfirmationDialog = false
    },
    cancelShareAlert() {
      this.isShared = false
      this.showShareAlertConfirmationDialog = false
    },
    onCloseDialog() {
      this.isShared = false
      this.showShareAlertConfirmationDialog = false
    },
    handleIsSharedDisabled() {
      if (this.isSharedDisabled) this.isShared = false
    },
  },
}
</script>

<style lang="scss">
.asc-advanced-custom-alerts-is-shared--wrapper {
  .v-input--selection-controls__input {
    transform: scale(0.8);
  }
  .v-label {
    font-size: 14px;
    color: $primary-black;
  }
  .isSharedMessage {
    color: $primary-black;
    font-size: $font-size-md;
    padding-top: 20px !important;
  }
  .asc-label {
    color: $gray-700;
  }
}
.asc-align {
  display: flex;
}
.inline-message {
  margin-top: 20px !important;
}
.asc-info-label--icon {
  color: #057874 !important;
}
</style>
